import React from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { ICameraInfo } from 'AppTypes'

type Props = {
  camera: ICameraInfo,
  index: number
}

const CameraInfo: React.FC<Props> = ({
  camera,
  index
}) => {
  const { t } = useTranslation()

  return (
    <div className={index > 0 ? 'row mt-5' : 'row'}>
      <h4 className="col-12">{camera.cameraName}</h4>
      <div className={camera.isOnAir ? 'video-item on col-7' : 'video-item off col-7'}>
        <div className="video-status">{t('liveStream.onAir')}</div>
        <div className="video-play">
          <img src={camera.imageThumbnail} alt="" />
        </div>
      </div>
      <div className="col-5">
        <button type="button" className={camera.isOnAir ? 'btn btn-common btn-outline-primary btn-block' : 'btn btn-common btn-block'}>{camera.isOnAir ? t('liveStream.stopLiveStream') : t('liveStream.startLiveStream')}</button>
        <div className="card mt-3 live-info">
          <div className="card-header text-center">
            <svg className="svg-inline--fa fa-user fa-w-14" aria-hidden="true" data-prefix="fas" data-icon="user" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z" /></svg>
            <span>{t('liveStream.numberOfViews')}</span>
          </div>
          <div className="card-body live-viewer">
            <div className="row no-gutters">
              <div className="col-6 text-center">
                <h3>{t('liveStream.currentViewers')}</h3>
                <div>
                  <span>{camera.isOnAir ? camera.stats?.current : '-'}</span>{t('liveStream.man')}
                </div>
              </div>
              <div className="col-6 text-center">
                <h3>{t('liveStream.totalViewers')}</h3>
                <div>
                  <span>{camera.isOnAir ? camera.stats?.total : '-'}</span>{t('liveStream.man')}
                </div>
              </div>
            </div>
          </div>
          <div className="card-header text-center">
            <svg className="svg-inline--fa fa-user fa-w-14" aria-hidden="true" data-prefix="fas" data-icon="user" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z" /></svg>
            <span>{t('liveStream.audienceRanking')}</span>
          </div>
          <div className="card-body live-ranking">
            <div className="row no-gutters">
              <div className="col-6 text-center">
                <div>
                  {camera.isOnAir && (
                    <>
                      <span>{camera.isOnAir ? camera.stats?.rank : '-'}</span>{t('liveStream.rank')}
                    </>
                  )}
                </div>
              </div>
              <div className="col-6 text-center">
                <div>
                  {camera.isOnAir && (
                    <><span>{camera.isOnAir ? camera.stats?.totalRank : '-'}</span>{t('liveStream.shop')}</>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CameraInfo
